import { Injectable } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { Subject } from 'rxjs';
import { AsyncResult } from '../../utils/asyncresult';
import { AppEventsControllerService } from '../app-events-controller.service';

@Injectable({ providedIn: 'root' })
export class DocumentSelectionChangedService {
  private selectionSubject = new Subject<Office.DocumentSelectionChangedEventArgs>();
  selectionChanged$ = this.selectionSubject.asObservable();

  constructor(appEventsControllerService: AppEventsControllerService, messageNotificationService: MessageNotificationService) {
    const subscription = appEventsControllerService.appReady$.subscribe((_) => {
      subscription.unsubscribe();
      this.addDocumentSelectionChangedHandler(messageNotificationService);
      // triggers all observers of selectionChanged to fire
      this.forceSelectionEvent();
    });

    Word.run(async (ctx) => {
      ctx.document.onContentControlAdded.add(async (event: Word.ContentControlAddedEventArgs) => {
        console.log('onContentControlAdded', event);
      });
      await ctx.sync();
    });
  }

  private addDocumentSelectionChangedHandler(messageNotificationService: MessageNotificationService): void {
    // more than one handler seems a bit flaky (even with unique function handler names)
    // add one handler and let any observers know
    Office.context.document.addHandlerAsync(
      Office.EventType.DocumentSelectionChanged,
      (eventArgs: Office.DocumentSelectionChangedEventArgs) => {
        this.selectionSubject.next(eventArgs);
      },
      (result) => {
        if (!AsyncResult.succeeded(result)) {
          messageNotificationService.error('Failed to register selection handler.', result.error);
        }
      }
    );
  }

  private forceSelectionEvent(): void {
    Word.run(async (context) => {
      const currSel = context.document.getSelection();
      if (currSel) {
        // doing this should trigger an event, but it doesn't
        // currSel.select(); await context.sync();
        console.debug('Forcing selection change event.');
        this.selectionSubject.next({
          type: Office.EventType.DocumentSelectionChanged,
          document: Office.context.document,
        });
      }
    });
  }
}
